export const countryCodes = [
  {
    "country": "AT",
    "name": "Austria",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "23"
  },
  {
    "country": "BE",
    "name": "Belgium",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "23"
  },
  {
    "country": "BG",
    "name": "Bulgaria",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "HR",
    "name": "Croatia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "CY",
    "name": "Cyprus",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "CZ",
    "name": "Czech Republic",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "DK",
    "name": "Denmark",
    "eu": true,
    "language": "da",
    "currency": "DKK",
    "pricelist": "27",
    "market": "15"
  },
  {
    "country": "EE",
    "name": "Estonia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "FI",
    "name": "Finland",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "FR",
    "name": "France",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "23"
  },
  {
    "country": "DE",
    "name": "Germany",
    "eu": true,
    "language": "de",
    "currency": "EUR",
    "pricelist": "29",
    "market": "23"
  },
  {
    "country": "GI",
    "name": "Gibraltar",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "GR",
    "name": "Greece",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "HU",
    "name": "Hungary",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "IE",
    "name": "Ireland",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "IT",
    "name": "Italy",
    "eu": true,
    "language": "en",
    "states": [
      {
        "state": "AG",
        "name": "Agrigento"
      },
      {
        "state": "AL",
        "name": "Alessandria"
      },
      {
        "state": "AN",
        "name": "Ancona"
      },
      {
        "state": "AO",
        "name": "Aosta"
      },
      {
        "state": "AR",
        "name": "Arezzo"
      },
      {
        "state": "AP",
        "name": "Ascoli Piceno"
      },
      {
        "state": "AT",
        "name": "Asti"
      },
      {
        "state": "AV",
        "name": "Avellino"
      },
      {
        "state": "BA",
        "name": "Bari"
      },
      {
        "state": "BT",
        "name": "Barletta-Andria-Trani"
      },
      {
        "state": "BL",
        "name": "Belluno"
      },
      {
        "state": "BN",
        "name": "Benevento"
      },
      {
        "state": "BG",
        "name": "Bergamo"
      },
      {
        "state": "BI",
        "name": "Biella"
      },
      {
        "state": "BO",
        "name": "Bologna"
      },
      {
        "state": "BZ",
        "name": "Bolzano"
      },
      {
        "state": "BS",
        "name": "Brescia"
      },
      {
        "state": "BR",
        "name": "Brindisi"
      },
      {
        "state": "CA",
        "name": "Cagliari"
      },
      {
        "state": "CL",
        "name": "Caltanissetta"
      },
      {
        "state": "CB",
        "name": "Campobasso"
      },
      {
        "state": "CI",
        "name": "Carbonia-Iglesias"
      },
      {
        "state": "CE",
        "name": "Caserta"
      },
      {
        "state": "CT",
        "name": "Catania"
      },
      {
        "state": "CZ",
        "name": "Catanzaro"
      },
      {
        "state": "CH",
        "name": "Chieti"
      },
      {
        "state": "CO",
        "name": "Como"
      },
      {
        "state": "CS",
        "name": "Cosenza"
      },
      {
        "state": "CR",
        "name": "Cremona"
      },
      {
        "state": "KR",
        "name": "Crotone"
      },
      {
        "state": "CN",
        "name": "Cuneo"
      },
      {
        "state": "EN",
        "name": "Enna"
      },
      {
        "state": "FM",
        "name": "Fermo"
      },
      {
        "state": "FE",
        "name": "Ferrara"
      },
      {
        "state": "FI",
        "name": "Firenze"
      },
      {
        "state": "FG",
        "name": "Foggia"
      },
      {
        "state": "FC",
        "name": "Forlì-Cesena"
      },
      {
        "state": "FR",
        "name": "Frosinone"
      },
      {
        "state": "GE",
        "name": "Genova"
      },
      {
        "state": "GO",
        "name": "Gorizia"
      },
      {
        "state": "GR",
        "name": "Grosseto"
      },
      {
        "state": "IM",
        "name": "Imperia"
      },
      {
        "state": "IS",
        "name": "Isernia"
      },
      {
        "state": "AQ",
        "name": "L'Aquila"
      },
      {
        "state": "SP",
        "name": "La Spezia"
      },
      {
        "state": "LT",
        "name": "Latina"
      },
      {
        "state": "LE",
        "name": "Lecce"
      },
      {
        "state": "LC",
        "name": "Lecco"
      },
      {
        "state": "LI",
        "name": "Livorno"
      },
      {
        "state": "LO",
        "name": "Lodi"
      },
      {
        "state": "LU",
        "name": "Lucca"
      },
      {
        "state": "MC",
        "name": "Macerata"
      },
      {
        "state": "MN",
        "name": "Mantova"
      },
      {
        "state": "MS",
        "name": "Massa-Carrara"
      },
      {
        "state": "MT",
        "name": "Matera"
      },
      {
        "state": "VS",
        "name": "Medio Campidano"
      },
      {
        "state": "ME",
        "name": "Messina"
      },
      {
        "state": "MI",
        "name": "Milano"
      },
      {
        "state": "MO",
        "name": "Modena"
      },
      {
        "state": "MB",
        "name": "Monza e della Brianza"
      },
      {
        "state": "NA",
        "name": "Napoli"
      },
      {
        "state": "NO",
        "name": "Novara"
      },
      {
        "state": "NU",
        "name": "Nuoro"
      },
      {
        "state": "OG",
        "name": "Ogliastra"
      },
      {
        "state": "OT",
        "name": "Olbia-Tempio"
      },
      {
        "state": "OR",
        "name": "Oristano"
      },
      {
        "state": "PD",
        "name": "Padova"
      },
      {
        "state": "PA",
        "name": "Palermo"
      },
      {
        "state": "PR",
        "name": "Parma"
      },
      {
        "state": "PV",
        "name": "Pavia"
      },
      {
        "state": "PG",
        "name": "Perugia"
      },
      {
        "state": "PU",
        "name": "Pesaro e Urbino"
      },
      {
        "state": "PE",
        "name": "Pescara"
      },
      {
        "state": "PC",
        "name": "Piacenza"
      },
      {
        "state": "PI",
        "name": "Pisa"
      },
      {
        "state": "PT",
        "name": "Pistoia"
      },
      {
        "state": "PN",
        "name": "Pordenone"
      },
      {
        "state": "PZ",
        "name": "Potenza"
      },
      {
        "state": "PO",
        "name": "Prato"
      },
      {
        "state": "RG",
        "name": "Ragusa"
      },
      {
        "state": "RA",
        "name": "Ravenna"
      },
      {
        "state": "RC",
        "name": "Reggio Calabria"
      },
      {
        "state": "RE",
        "name": "Reggio Emilia"
      },
      {
        "state": "RI",
        "name": "Rieti"
      },
      {
        "state": "RN",
        "name": "Rimini"
      },
      {
        "state": "RM",
        "name": "Roma"
      },
      {
        "state": "RO",
        "name": "Rovigo"
      },
      {
        "state": "SA",
        "name": "Salerno"
      },
      {
        "state": "SS",
        "name": "Sassari"
      },
      {
        "state": "SV",
        "name": "Savona"
      },
      {
        "state": "SI",
        "name": "Siena"
      },
      {
        "state": "SR",
        "name": "Siracusa"
      },
      {
        "state": "SO",
        "name": "Sondrio"
      },
      {
        "state": "SU",
        "name": "Sud Sardegna"
      },
      {
        "state": "TA",
        "name": "Taranto"
      },
      {
        "state": "TE",
        "name": "Teramo"
      },
      {
        "state": "TR",
        "name": "Terni"
      },
      {
        "state": "TO",
        "name": "Torino"
      },
      {
        "state": "TP",
        "name": "Trapani"
      },
      {
        "state": "TN",
        "name": "Trento"
      },
      {
        "state": "TV",
        "name": "Treviso"
      },
      {
        "state": "TS",
        "name": "Trieste"
      },
      {
        "state": "UD",
        "name": "Udine"
      },
      {
        "state": "VA",
        "name": "Varese"
      },
      {
        "state": "VE",
        "name": "Venezia"
      },
      {
        "state": "VB",
        "name": "Verbano-Cusio-Ossola"
      },
      {
        "state": "VC",
        "name": "Vercelli"
      },
      {
        "state": "VR",
        "name": "Verona"
      },
      {
        "state": "VV",
        "name": "Vibo Valentia"
      },
      {
        "state": "VI",
        "name": "Vicenza"
      },
      {
        "state": "VT",
        "name": "Viterbo"
      }
    ],
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "LV",
    "name": "Latvia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "LT",
    "name": "Lithuania",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "LU",
    "name": "Luxembourg",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "MT",
    "name": "Malta",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "NL",
    "name": "Netherlands",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "23"
  },
  {
    "country": "NO",
    "name": "Norway",
    "eu": false,
    "language": "no",
    "currency": "NOK",
    "pricelist": "28",
    "market": "25"
  },
  {
    "country": "PL",
    "name": "Poland",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "PT",
    "name": "Portugal",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "RO",
    "name": "Romania",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "SK",
    "name": "Slovakia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "SI",
    "name": "Slovenia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "15"
  },
  {
    "country": "ES",
    "name": "Spain",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "29",
    "market": "22"
  },
  {
    "country": "SE",
    "name": "Sweden",
    "eu": true,
    "language": "sv",
    "currency": "SEK",
    "pricelist": "19",
    "market": "15"
  },
  {
    "country": "GB",
    "name": "United Kingdom",
    "eu": false,
    "language": "en",
    "states": [
      {
        "state": "GB-ENG",
        "name": "England"
      },
      {
        "state": "GB-NIR",
        "name": "Northern Ireland"
      },
      {
        "state": "GB-SCT",
        "name": "Scotland"
      },
      {
        "state": "GB-WLS",
        "name": "Wales"
      }
    ],
    "currency": "GBP",
    "pricelist": "33",
    "market": "16"
  }
];